import { Trip } from "../../parsegenerated";

export class TripModel {
  trip_id?: string;
  route_id?: string;
  trip_headsign?: string;
  trip_short_name?: string;
  trip_weekdays?: number[];
}

export function toTripModel(data: Trip): TripModel {
  const calendar = data.service_id;
  const weekdays: number[] = [];

  if (calendar.get("monday")) weekdays.push(1);
  if (calendar.get("tuesday")) weekdays.push(2);
  if (calendar.get("wednesday")) weekdays.push(3);
  if (calendar.get("thursday")) weekdays.push(4);
  if (calendar.get("friday")) weekdays.push(5);
  if (calendar.get("saturday")) weekdays.push(6);
  if (calendar.get("sunday")) weekdays.push(7);

  return {
    trip_id: data.id,
    route_id: data.route_id.get("route_id"),
    trip_headsign: data.trip_headsign,
    trip_short_name: data.trip_short_name,
    trip_weekdays: weekdays,
  };
}
